export { default } from "./ResponsiveAccordion";
